import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { debounce } from '@particles/debounce'
import useMousePosition from '@particles/useMousePosition'

const HideHeader = (WrappedComponent) => {
	const NewComponent = () => {
		const [prevScrollPos, setPrevScrollPos] = useState(0)
		const [visible, setVisible] = useState(true)
		const { y } = useMousePosition()
		const location = useLocation()

		const handleScroll = debounce(() => {
			if (location && location?.pathname !== '/') {
				const currentScrollPos = window.pageYOffset
				setVisible(
					(prevScrollPos > currentScrollPos &&
						prevScrollPos - currentScrollPos > 70) ||
						currentScrollPos < 10
				)
				setPrevScrollPos(currentScrollPos)
			}
		}, 100)

		useEffect(() => {
			window.addEventListener('scroll', handleScroll)
			!visible && y && setVisible(y < 100)

			return () => window.removeEventListener('scroll', handleScroll)
		}, [prevScrollPos, visible, handleScroll])

		return <WrappedComponent visible={visible} location={location} />
	}
	return NewComponent
}
export default HideHeader
